export default {
    home: 'Home',
    fundingPrograms: 'Förderprogramme',
    notifications: 'Benachrichtigungen',
    myProfile: 'Mein Profil',
    myOrganisation: 'Meine Organisation',
    myUsers: 'Nutzer',
    myChildOrganisations: 'Meine Untergliederungen',
    login: 'Login',
    logout: 'Logout',
    service: 'Intern',
    dashboard: 'Dashboard',
    processes: 'Maßnahmen',
    payment: 'Zahlungsjournal',
    reporting: 'Auswertungen',
    info: 'Info',
    users: 'Nutzer',
    childOrganisations: 'Untergliederungen',
    organisations: 'Organisationen',
    basicData: 'Stammdaten',
    forms: 'Formulare',
    categories: 'Kategorien',
    statuses: 'Status',
    roles: 'Rollen',
    years: 'Jahre',
    mailTemplates: 'E-Mailvorlagen',
    mails: 'E-Mails',
    ags: 'AGS',
    information: 'Informationen',
    settings: 'Einstellungen',
    loginProviders: 'Login Methoden',
    paymentRuns: 'Zahlungsläufe',

    secret: 'Geheimnis',
    nothingToSeeHere: 'Hier gibt es nichts zu sehen 🙈',
    escapeRoom: '//farbcode Dungeon Escape! 🏰',
    dungeon: 'Dungeon',
    overview: 'Input-Übersicht'
}
